import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `/mom/work-order/{id}/reopen`。CLOSED → PROCESSING。
 * body：`reopenReason?`、`updatedAt`。
 */
export async function reopenWorkOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/mom/work-order/${id}/reopen`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
